import { api } from "./baseApi";

export interface SupportRequestFormData {
  locationIds: string[];
  transactionId?: string;
  description: string;
  attachments?: File | null;
}

export interface DeleteRequestFormData {
  description: string;
}

export interface SupportRequestResponse {
  success: boolean;
  message: string;
  ticketId?: string;
}

export const supportApi = {  
  submitSupportRequest: async (
    formData: SupportRequestFormData
  ): Promise<SupportRequestResponse> => {    
    const requestFormData = new FormData();
    
    formData.locationIds.forEach((locationId) => {
      requestFormData.append("LocationIds", locationId);
    });
    
    requestFormData.append("OrderId", formData.transactionId || "");
    requestFormData.append("Description", formData.description);
    
    if (formData.attachments) {
      requestFormData.append("Attachments", formData.attachments);
    }

    const response = await api.postFormData<SupportRequestResponse>(
      "/merchant/support",
      requestFormData
    );

    return response.data;
  },

  submitDeleteRequest: async (
    formData: DeleteRequestFormData
  ): Promise<SupportRequestResponse> => {    
    const requestFormData = new FormData();
    requestFormData.append("OrderId", "");
    requestFormData.append("Description", formData.description);

    const response = await api.postFormData<SupportRequestResponse>(
      "/merchant/support",
      requestFormData
    );

    return response.data;
  },
};
